// extracted by mini-css-extract-plugin
module.exports = {"container":"_28fdH","header":"_3pqaE","content":"_1YVNU","controls":"Yztpc","isLayoutTextOnImage":"_1V5kJ"};